angular.module('bmsApp.merrymaids.job')
	.controller('BulkInactiveCtrl', BulkInactiveCtrl);

BulkInactiveCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'$ngBootbox',
	'notify',
	'MMJobPartSvc',
];

function BulkInactiveCtrl(
	$scope,
	$state,
	$q,
	$ngBootbox,
	notify,
	MMJobPartSvc,
) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: true,
		handlers: handlers,
		dateRangeOptions: {},
		inactiveCount: 0,
		processing: false,
	});

	this.$onInit = () => {
		self.dateRangeOptions = $scope.config.datePicker.range;
		// self.dateRangeOptions.options.minDate = moment();
		self.dateRangeOptions.options.format = $scope.config.format.date.amShortDate;
		self.dateRangeOptions.options.opens = 'right';
		delete self.dateRangeOptions.options.ranges.Today;
		delete self.dateRangeOptions.options.ranges.Yesterday;

		self.loading = false;
	};

	function calculateInactive() {
		self.inactiveCount = 0;
		angular.forEach(self.jobPartCollection, (item) => {
			angular.forEach(item.job_parts, (jobPart) => {
				if (jobPart.selected) {
					self.inactiveCount++;
				}
			});
		});
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.loadJobPartsClick = () => {
		self.loading = true;
		let params = {
			filter: {
				dateRange: self.dateRange,
				active: true,
			}
		};
		MMJobPartSvc.index(params).then((response) => {
			self.jobPartCollectionTmp = response.data.collection;
			let jobPartsByCustomer = _.groupBy(self.jobPartCollectionTmp, (jobPart) =>
			{
				return jobPart.job.customer.id;
			});

			self.jobPartCollection = [];

			// Transform the data to give easy access to customer object and jobs
			angular.forEach(jobPartsByCustomer, (customerObject) => {
				self.jobPartCollection.push({
					customer: customerObject[0].job.customer,
					job_parts: customerObject,
				});
			});
			self.loading = false;
		});
	};

	handlers.selectAllClick = () => {
		angular.forEach(self.jobPartCollection, (item) => {
			angular.extend(item, {
				selected: self.selectAll,
			});
			angular.forEach(item.job_parts, (jobPart) => {
				angular.extend(jobPart, {
					selected: self.selectAll,
				});
			});
		});
		calculateInactive();
	};

	handlers.customerClick = (item) => {
		angular.forEach(item.job_parts, (jobPart) => {
			angular.extend(jobPart, {
				selected: item.selected,
			});
		});
		calculateInactive();
	};

	handlers.jobPartClick = (item) => {
		calculateInactive();
	};



	handlers.submitClick = () => {
		$ngBootbox.confirm('CAUTION: Are you sure you want to make ' + self.inactiveCount + ' job parts inactive? THIS CANNOT BE UNDONE')
			.then(function () {
				self.processing = true;
				let jobPartIds = [];
				angular.forEach(self.jobPartCollection, (item) => {
					angular.forEach(item.job_parts, (jobPart) => {
						if (jobPart.selected) {
							jobPartIds.push(jobPart.id);
						}
					});
				});

				let params = {
					jobPartIds: jobPartIds,
				};

				MMJobPartSvc.bulkInactive(params).then((response) => {
					notify({
						message: self.inactiveCount + ' job parts made inactive',
					});
					self.selectAll = false;
					self.processing = false;
					handlers.loadJobPartsClick();
				});

			});
	};
}
